import { MasterlistManager } from "./MasterlistManager";
import { ServiceFeeNetworkHelper } from "./NetworkHelper";
import { ServiceFeeProviderManager } from "./ProviderManager";

export class ServiceFeeManager {
    networkHelper = ServiceFeeNetworkHelper;
    masterlist = new MasterlistManager();
    provider = new ServiceFeeProviderManager();
}
